/** Identificadores IANA comuns — campo com `list=` + `<datalist>` na configuração da loja. */
export const STORE_TIMEZONE_IANA_SUGGESTIONS = [
  'America/Sao_Paulo',
  'America/Manaus',
  'America/Fortaleza',
  'America/Belem',
  'America/Recife',
  'America/Cuiaba',
  'America/Campo_Grande',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Rio_Branco',
  'America/Noronha',
  'America/Bahia',
  'America/Maceio',
  'America/Araguaina',
  'America/Santarem',
  'Atlantic/Azores',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Paris',
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/Argentina/Buenos_Aires',
  'Africa/Lagos',
];
